import React from 'react';
import PropTypes from 'prop-types';
import '../FormPassword/FormPassword.scss';

const FormPassword = (props) => {
  const { name, label, placeholder, maxLength, required, input, autotestClass, meta: { touched, error } } = props;
  const hasError = touched && error;
  return (<div className="form-password relative">
    <label htmlFor={name}>{label}</label>
    {required &&
    <span className="form-required-text">*</span>
    }
    <input
      className={`input form-control ${autotestClass} ${hasError ? 'form-password-error' : ''}`}
      name={name}
      type="password"
      placeholder={placeholder}
      maxLength={maxLength}
      {...input}
    />
    {hasError &&
    <span className="form-validation-message">{error}</span>
    }
  </div>);
};

FormPassword.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  autotestClass: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default FormPassword;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormPassword/FormPassword.js
 **/